export default __webpack_public_path__ + "static/media/eye.947c3232.svg";